export const regulatorTypes = {
    PRIMARY_REGULATOR: '01',
    SPECIALIST: '02',
    INTERNAL: '03',
    OTHER: '04',
}

export const isPrimaryRegulator = type =>
    type === regulatorTypes.PRIMARY_REGULATOR
